import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=157651ba&scoped=true&"
import script from "./SimpleTable.vue?vue&type=script&lang=js&"
export * from "./SimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&id=157651ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157651ba",
  null
  
)

export default component.exports